import axios from 'axios'

export const getQueues = () => {
  return axios.get('/finance/queues')
}
